export default __webpack_public_path__ + "static/media/polk_liveauction_product.81757632.jpg";